import React from 'react';
import ReactDOM from 'react-dom';
import BlogBuilder from '../../components/blog/BlogBuilder.jsx';

document.addEventListener('DOMContentLoaded', () => {
  const blogContent = document.getElementById('blogcontent');
  if (blogContent !== null && blogContent !== undefined) {
    ReactDOM.render(
      <BlogBuilder {...blogContent.dataset} status={'published'} />,
      blogContent
    );
  }
})
